import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div>
    <h1>Not Found.</h1>
    <Link to="/">Return to Homepage</Link>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js